const formatterDigits = new Intl.NumberFormat('en-US')

export const formatDigits = (value) => {
  return formatterDigits.format(value)
}
